import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const NavigationSafetyContext = createContext<{
  dirty: boolean; busy: boolean; update: (id: symbol, dirty: boolean, busy: boolean) => void;
} | null>(null);

export function NavigationSafetyProvider({ children }: { children: React.ReactNode }) {
  const [entries, setEntries] = useState(new Map<symbol, { dirty: boolean; busy: boolean }>());
  const update = useCallback((id: symbol, dirty: boolean, busy: boolean) => {
    setEntries(previous => {
      const next = new Map(previous);
      if (dirty || busy) next.set(id, { dirty, busy }); else next.delete(id);
      return next;
    });
  }, []);
  const value = useMemo(() => ({ dirty: Array.from(entries.values()).some(entry => entry.dirty), busy: Array.from(entries.values()).some(entry => entry.busy), update }), [entries, update]);
  return <NavigationSafetyContext.Provider value={value}>{children}</NavigationSafetyContext.Provider>;
}

export const useNavigationSafety = () => useContext(NavigationSafetyContext);
